/* Next10 — Stories da PDP (snippets/n10-stories.liquid).
   Abre em tela cheia a partir da bolinha tocada e segue a sequência inteira,
   como os stories de um perfil no Instagram:
   - barras de progresso no topo; imagem dura data-duracao segundos, vídeo dura
     o próprio vídeo;
   - toque no terço esquerdo volta, no resto avança; segurar pausa; arrastar
     para baixo fecha; Esc/setas/espaço no teclado;
   - botão de som nos vídeos (tenta com som, pois a abertura veio de um toque;
     se o navegador bloquear, cai no mudo);
   - bolinha fica cinza depois de vista (localStorage, só neste navegador);
   - botão voltar do celular fecha o story em vez de sair da página.
   O visualizador é criado no <body> só na primeira abertura. */
if (!customElements.get('n10-stories')) {
  var N10_ICONES = {
    fechar: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    pausar: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="4" height="16" rx="1" fill="currentColor"/><rect x="14" y="4" width="4" height="16" rx="1" fill="currentColor"/></svg>',
    tocar: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15a1 1 0 0 0 1.5.86l12.5-7.5a1 1 0 0 0 0-1.72L8.5 3.64A1 1 0 0 0 7 4.5z" fill="currentColor"/></svg>',
    somOn: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    somOff: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M17 9.5l5 5M22 9.5l-5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>',
    ant: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    prox: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>'
  };

  var N10_VISTOS_CHAVE = 'n10-stories-vistos';
  function n10LerVistos() {
    try { return JSON.parse(localStorage.getItem(N10_VISTOS_CHAVE) || '[]'); } catch (e) { return []; }
  }
  function n10MarcarVisto(chave) {
    try {
      var lista = n10LerVistos();
      if (lista.indexOf(String(chave)) === -1) {
        lista.push(String(chave));
        localStorage.setItem(N10_VISTOS_CHAVE, JSON.stringify(lista.slice(-200)));
      }
    } catch (e) {}
  }

  class N10Stories extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      try {
        this.itens = JSON.parse(this.querySelector('[data-n10-stories-dados]').textContent);
      } catch (e) {
        this.itens = [];
      }
      this.bolinhas = Array.prototype.slice.call(this.querySelectorAll('.n10-stories__bolinha'));
      this.duracaoImagem = (parseFloat(this.dataset.duracao) || 5) * 1000;

      var vistos = n10LerVistos();
      this.bolinhas.forEach(function (b) {
        if (vistos.indexOf(String(b.dataset.chave)) !== -1) b.classList.add('is-visto');
      });

      this.addEventListener('click', function (e) {
        var b = e.target.closest('.n10-stories__bolinha');
        if (!b) return;
        /* detail 0 = ativado pelo teclado (Enter/Espaço), não por toque/mouse */
        this.abrir(parseInt(b.dataset.indice, 10) || 0, b, e.detail === 0);
      }.bind(this));

      this._tick = this.tick.bind(this);
      this._tecla = this.tecla.bind(this);
      this._popstate = this.popstate.bind(this);
      this._visibilidade = function () { if (document.hidden && this.aberto) this.pausar(true); }.bind(this);
    }

    /* ---------- montagem do visualizador ---------- */
    montar() {
      if (this.v) return;
      var d = this.dataset;
      var v = document.createElement('div');
      v.className = 'n10-sv';
      v.setAttribute('role', 'dialog');
      v.setAttribute('aria-modal', 'true');
      v.setAttribute('aria-label', 'Stories');
      var barras = this.itens.map(function () { return '<span class="n10-sv__barra"><i></i></span>'; }).join('');
      v.innerHTML =
        '<button type="button" class="n10-sv__fechar" aria-label="' + (d.rotuloFechar || 'Fechar') + '">' + N10_ICONES.fechar + '</button>' +
        '<div class="n10-sv__moldura">' +
          '<div class="n10-sv__palco">' +
            '<div class="n10-sv__midia"></div>' +
            '<span class="n10-sv__carregando" hidden></span>' +
            '<div class="n10-sv__barras">' + barras + '</div>' +
            '<div class="n10-sv__topo">' +
              (d.avatar ? '<img class="n10-sv__avatar" src="' + d.avatar + '" alt="" width="32" height="32">' : '') +
              '<span class="n10-sv__nome"></span>' +
              '<span class="n10-sv__titulo"></span>' +
              '<span class="n10-sv__acoes">' +
                '<button type="button" class="n10-sv__btn n10-sv__btn--pausa" aria-label="Pausar">' + N10_ICONES.pausar + '</button>' +
                '<button type="button" class="n10-sv__btn n10-sv__btn--som" aria-label="Desativar som" hidden>' + N10_ICONES.somOn + '</button>' +
                '<button type="button" class="n10-sv__btn n10-sv__btn--fechar-palco" aria-label="' + (d.rotuloFechar || 'Fechar') + '">' + N10_ICONES.fechar + '</button>' +
              '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="n10-sv__seta n10-sv__seta--ant" aria-label="Story anterior">' + N10_ICONES.ant + '</button>' +
          '<button type="button" class="n10-sv__seta n10-sv__seta--prox" aria-label="Próximo story">' + N10_ICONES.prox + '</button>' +
        '</div>';
      document.body.appendChild(v);

      this.v = v;
      this.palco = v.querySelector('.n10-sv__palco');
      this.midia = v.querySelector('.n10-sv__midia');
      this.carregando = v.querySelector('.n10-sv__carregando');
      this.fills = Array.prototype.slice.call(v.querySelectorAll('.n10-sv__barra i'));
      this.elTitulo = v.querySelector('.n10-sv__titulo');
      this.btnPausa = v.querySelector('.n10-sv__btn--pausa');
      this.btnSom = v.querySelector('.n10-sv__btn--som');
      this.setaAnt = v.querySelector('.n10-sv__seta--ant');
      this.setaProx = v.querySelector('.n10-sv__seta--prox');
      v.querySelector('.n10-sv__nome').textContent = d.nome || '';
      this.mudo = false;

      v.querySelector('.n10-sv__fechar').addEventListener('click', this.fechar.bind(this, false));
      v.querySelector('.n10-sv__btn--fechar-palco').addEventListener('click', this.fechar.bind(this, false));
      this.setaAnt.addEventListener('click', this.anterior.bind(this));
      this.setaProx.addEventListener('click', this.proximo.bind(this));
      this.btnPausa.addEventListener('click', function () { this.pausar(!this.pausado); }.bind(this));
      this.btnSom.addEventListener('click', function () { this.definirMudo(!this.mudo); }.bind(this));

      /* toque: terço esquerdo volta, resto avança; segurar pausa; arrastar p/ baixo fecha */
      var self = this;
      this.palco.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
        self.gesto = { x: e.clientX, y: e.clientY, segurando: false, id: e.pointerId };
        self.timerSegurar = setTimeout(function () {
          if (!self.gesto) return;
          self.gesto.segurando = true;
          self.pausar(true, true);
        }, 220);
      });
      this.palco.addEventListener('pointermove', function (e) {
        if (!self.gesto || e.pointerId !== self.gesto.id) return;
        var dy = e.clientY - self.gesto.y;
        if (dy > 12) {
          clearTimeout(self.timerSegurar);
          self.palco.style.transform = 'translateY(' + dy + 'px) scale(' + Math.max(0.85, 1 - dy / 1600) + ')';
          self.palco.style.opacity = String(Math.max(0.4, 1 - dy / 600));
        }
      });
      var soltar = function (e) {
        if (!self.gesto || e.pointerId !== self.gesto.id) return;
        clearTimeout(self.timerSegurar);
        var g = self.gesto;
        self.gesto = null;
        var dy = e.clientY - g.y;
        self.palco.style.transform = '';
        self.palco.style.opacity = '';
        if (e.type === 'pointercancel') { if (g.segurando) self.pausar(false); return; }
        if (dy > 90) { self.fechar(false); return; }
        if (g.segurando) { self.pausar(false); return; }
        if (Math.abs(e.clientX - g.x) > 30 || Math.abs(dy) > 30) return;
        var r = self.palco.getBoundingClientRect();
        if (e.clientX - r.left < r.width / 3) self.anterior(); else self.proximo();
      };
      this.palco.addEventListener('pointerup', soltar);
      this.palco.addEventListener('pointercancel', soltar);
      this.palco.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }

    /* ---------- abrir / fechar ---------- */
    abrir(indice, origem, porTeclado) {
      if (!this.itens.length) return;
      this.montar();
      this.origem = origem || null;
      this.abertoPorTeclado = !!porTeclado;
      this.aberto = true;
      this.v.classList.add('is-aberto');
      document.documentElement.classList.add('n10-sv-travado');
      document.addEventListener('keydown', this._tecla);
      document.addEventListener('visibilitychange', this._visibilidade);
      window.addEventListener('popstate', this._popstate);
      try { history.pushState({ n10Story: true }, ''); this.comHistorico = true; } catch (e) { this.comHistorico = false; }
      this.mostrar(indice);
      /* Teclado: foco no 1º controle. Toque/mouse: foco no próprio diálogo, sem
         anel visível em nenhum botão. */
      if (porTeclado) {
        this.btnPausa.focus({ preventScroll: true });
      } else {
        this.v.setAttribute('tabindex', '-1');
        this.v.focus({ preventScroll: true });
      }
      cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(this._tick);
    }

    fechar(porHistorico, porTeclado) {
      if (!this.aberto) return;
      this.aberto = false;
      cancelAnimationFrame(this.raf);
      this.limparMidia();
      this.v.classList.remove('is-aberto');
      document.documentElement.classList.remove('n10-sv-travado');
      document.removeEventListener('keydown', this._tecla);
      document.removeEventListener('visibilitychange', this._visibilidade);
      window.removeEventListener('popstate', this._popstate);
      if (!porHistorico && this.comHistorico && history.state && history.state.n10Story) {
        try { history.back(); } catch (e) {}
      }
      /* Devolve o foco à bolinha só para quem navega pelo teclado; no toque/mouse
         o foco na bolinha deixava ela com cara de "selecionada". */
      if (this.origem && (porTeclado || this.abertoPorTeclado)) {
        this.origem.focus({ preventScroll: true });
      } else if (document.activeElement && this.v.contains(document.activeElement)) {
        document.activeElement.blur();
      }
    }

    popstate() {
      if (this.aberto) this.fechar(true);
    }

    tecla(e) {
      if (!this.aberto) return;
      if (e.key === 'Escape') { e.preventDefault(); this.fechar(false, true); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); this.proximo(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); this.anterior(); }
      else if (e.key === ' ' && !(e.target && e.target.closest && e.target.closest('button'))) { e.preventDefault(); this.pausar(!this.pausado); }
      else if (e.key === 'Tab') {
        var focaveis = Array.prototype.filter.call(this.v.querySelectorAll('button'), function (b) { return b.offsetParent !== null && !b.disabled; });
        if (!focaveis.length) return;
        var i = focaveis.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); focaveis[focaveis.length - 1].focus(); }
        else if (!e.shiftKey && i === focaveis.length - 1) { e.preventDefault(); focaveis[0].focus(); }
      }
    }

    /* ---------- navegação ---------- */
    proximo() {
      if (this.indice + 1 >= this.itens.length) { this.fechar(false); return; }
      this.mostrar(this.indice + 1);
    }

    anterior() {
      if (this.indice <= 0) { this.mostrar(0); return; }
      this.mostrar(this.indice - 1);
    }

    limparMidia() {
      if (this.video) {
        this.video.pause();
        this.video.removeAttribute('src');
        this.video.load();
        this.video = null;
      }
      this.midia.innerHTML = '';
    }

    mostrar(indice) {
      var item = this.itens[indice];
      if (!item) return;
      this.indice = indice;
      this.decorrido = 0;
      this.duracao = this.duracaoImagem;
      this.carregado = false;
      this.limparMidia();
      this.pausar(false);

      this.fills.forEach(function (f, i) {
        f.style.transform = 'scaleX(' + (i < indice ? 1 : 0) + ')';
      });
      this.elTitulo.textContent = item.titulo || '';
      this.setaAnt.disabled = indice === 0;
      this.carregando.hidden = false;

      var self = this;
      var pronto = function () {
        if (self.itens[self.indice] !== item) return;
        self.carregado = true;
        self.carregando.hidden = true;
        self.ultimo = performance.now();
      };
      var contain = function (w, h) {
        if (!w || !h) return false;
        return Math.abs(w / h - 9 / 16) > 0.08;
      };

      if (item.tipo === 'video') {
        var video = document.createElement('video');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.preload = 'auto';
        if (item.poster) video.poster = item.poster;
        video.src = item.src;
        video.muted = this.mudo;
        if (item.alt) video.setAttribute('aria-label', item.alt);
        if (contain(item.largura, item.altura)) video.classList.add('is-contain');
        video.addEventListener('playing', pronto, { once: true });
        video.addEventListener('ended', function () { if (self.video === video) self.proximo(); });
        this.midia.appendChild(video);
        this.video = video;
        this.btnSom.hidden = false;
        this.atualizarSom();
        var tentativa = video.play();
        if (tentativa && tentativa.catch) {
          tentativa.catch(function () {
            if (self.video !== video) return;
            self.definirMudo(true);
            video.play().catch(function () { self.pausar(true); pronto(); });
          });
        }
      } else {
        this.btnSom.hidden = true;
        var img = new Image();
        img.decoding = 'async';
        img.alt = item.alt || '';
        if (item.srcset) { img.srcset = item.srcset; img.sizes = '(min-width: 750px) 50vh, 100vw'; }
        img.src = item.src;
        if (contain(item.largura, item.altura)) img.classList.add('is-contain');
        var carregou = function () { pronto(); };
        if (img.decode) img.decode().then(carregou, carregou); else img.onload = carregou;
        this.midia.appendChild(img);
      }

      var bolinha = this.bolinhas[indice];
      if (bolinha) bolinha.classList.add('is-visto');
      n10MarcarVisto(item.chave);

      /* pré-carrega a próxima imagem */
      var prox = this.itens[indice + 1];
      if (prox && prox.tipo === 'imagem') {
        var pre = new Image();
        if (prox.srcset) { pre.srcset = prox.srcset; pre.sizes = '(min-width: 750px) 50vh, 100vw'; }
        pre.src = prox.src;
      }
    }

    /* ---------- tempo ---------- */
    pausar(valor, porGesto) {
      this.pausado = !!valor;
      this.ultimo = performance.now();
      if (this.video) {
        if (this.pausado) this.video.pause();
        else if (this.carregado || !porGesto) { var p = this.video.play(); if (p && p.catch) p.catch(function () {}); }
      }
      if (this.btnPausa) {
        this.btnPausa.innerHTML = this.pausado ? N10_ICONES.tocar : N10_ICONES.pausar;
        this.btnPausa.setAttribute('aria-label', this.pausado ? 'Continuar' : 'Pausar');
      }
    }

    definirMudo(valor) {
      this.mudo = !!valor;
      if (this.video) this.video.muted = this.mudo;
      this.atualizarSom();
    }

    atualizarSom() {
      this.btnSom.innerHTML = this.mudo ? N10_ICONES.somOff : N10_ICONES.somOn;
      this.btnSom.setAttribute('aria-label', this.mudo ? 'Ativar som' : 'Desativar som');
    }

    tick(agora) {
      if (!this.aberto) return;
      var fill = this.fills[this.indice];
      if (this.carregado && !this.pausado) {
        if (this.video) {
          var dur = this.video.duration;
          if (dur && isFinite(dur)) {
            this.duracao = dur * 1000;
            this.decorrido = this.video.currentTime * 1000;
          }
        } else {
          this.decorrido += agora - (this.ultimo || agora);
        }
      }
      this.ultimo = agora;
      var progresso = this.duracao ? Math.min(this.decorrido / this.duracao, 1) : 0;
      if (fill) fill.style.transform = 'scaleX(' + progresso + ')';
      if (!this.video && this.carregado && progresso >= 1) {
        this.proximo();
      }
      this.raf = requestAnimationFrame(this._tick);
    }
  }

  customElements.define('n10-stories', N10Stories);
}
